export function getPlaceFromAddress(address: string, map?: google.maps.Map): Promise<google.maps.places.PlaceResult | null> {
	return new Promise((resolve, reject) => {
		if (!map) {
			map = new google.maps.Map(document.createElement('div'));
		}

		if (address && address.length > 0) {
			const request = {
				query: address,
				fields: ['formatted_address', 'id', 'name', 'geometry', 'place_id']
			};

			const service = new google.maps.places.PlacesService(map);

			service.findPlaceFromQuery(request, function (results, status) {
				if (status === google.maps.places.PlacesServiceStatus.OK) {
					resolve(results[0]);
				} else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
					resolve(null);
				} else {
					reject();
				}
			});
		} else {
			resolve(null);
		}
	});
}
